import React, { useReducer } from 'react';
import { defaultLoading, LoadingActionType, loadingReducer } from '../store/types/loading';
import { LoadingComponent } from '../components';

type LoadinContextType = [
  {
    loading: boolean,
    activeLoading: number
  },
  React.Dispatch<LoadingActionType>
]

export const LoadingContext = React.createContext<LoadinContextType | null>(null);

interface LoadingProviderProps {
  children: React.ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(loadingReducer, defaultLoading);
  return (
    <LoadingContext.Provider value={[state, dispatch]}>
      {
        state.loading &&
        <div className={'absolute z-10 h-screen w-screen bg-primary-100/30'}>
          <LoadingComponent />
        </div>
      }
      {children}
    </LoadingContext.Provider>
  );
};